
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lifecycle-studio/overview",
      function () {
        return require("private-next-pages/lifecycle-studio/overview.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lifecycle-studio/overview"])
      });
    }
  